import React, { useEffect, useState, useRef } from "react";
import toast from "react-hot-toast";
import api from "../api/Api.js";
// import "./DriverAttendancePageDaily.css";
import "./SalarySlipSinglePage.css";
import BrandLogo from "../assets/Logo Patra Travels (half white logo).png";
import logo from "../assets/logo.png";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
const SalarySlipSinglePage = () => {
    const navigate = useNavigate();
     const {reg,month,year} = useParams();
  const tableRef = useRef();
  
  const [saveConfirmAttendance, setSaveConfirmAttendance] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");

  const today = new Date();
const initialMonth = month ? Number(month) : new Date().getMonth();
const initialYear = year ? Number(year) : new Date().getFullYear();
  const [selectedMonth, setSelectedMonth] = useState(initialMonth);
const [getDriverId, setDriverId] = useState('');
  const [selectedYear, setSelectedYear] = useState(initialYear);
const [attendanceData, setAttendanceData] = useState([]);
const [hideButton, setHideButton] = useState(false);
  const months = [
    { value: "01", label: "January" },
    { value: "02", label: "February" },
    { value: "03", label: "March" },
    { value: "04", label: "April" },
    { value: "05", label: "May" },
    { value: "06", label: "June" },
    { value: "07", label: "July" },
    { value: "08", label: "August" },
    { value: "09", label: "September" },
    { value: "10", label: "October" },
    { value: "11", label: "November" },
    { value: "12", label: "December" },
  ];
const monthLabel = months.find(m => m.value === month)?.label;
  const years = Array.from({ length: 7 }, (_, i) =>
    String(today.getFullYear() - 5 + i)
  );

  useEffect(() => {
    fetchSaveConfirmAttendance();
    setSearchTerm(reg);
      setDriverId(reg);
      getAttendanceData();
  }, [selectedMonth, selectedYear]);
// console.log('month'+selectedMonth);
// console.log('year'+selectedYear);

const totalDaysMonth = new Date(selectedYear, selectedMonth, 0).getDate();
// console.log("total day"+totalDaysMonth);
  const getAttendanceData = async () => {
  const getMonth=selectedMonth;
  const getYear=selectedYear;


// Utility function
const getMonthDates = (month, year) => {
  // Convert to 0-based month index
  const monthIndex = Number(month) - 1;

  // First Date
  const firstDateObj = new Date(year, monthIndex, 1);

  const firstDate = `${firstDateObj.getFullYear()}-${String(
    monthIndex + 1
  ).padStart(2, "0")}-${String(firstDateObj.getDate()).padStart(2, "0")}`;

  // Last Date (next month ka 0th day)
  const lastDateObj = new Date(year, monthIndex + 1, 0);

  const lastDate = `${lastDateObj.getFullYear()}-${String(
    monthIndex + 1
  ).padStart(2, "0")}-${String(lastDateObj.getDate()).padStart(2, "0")}`;

  return { firstDate, lastDate };
};

// Call function
const { firstDate, lastDate } = getMonthDates(getMonth, getYear);

console.log("firstDate:", firstDate);
console.log("lastDate:", lastDate);
  try {
    const resp = await api.get(
      `/adminmodSalary/getDriverAttendance/${firstDate}/${lastDate}`
    );

    setAttendanceData(resp.data?.data || []);
  } catch (err) {
    toast.error("Attendance load failed");
  }
  };
 //FOR CALENDER CODE START//
 const daysInMonth = new Date(selectedYear, selectedMonth, 0).getDate();
const firstDay = new Date(selectedYear, selectedMonth, 1).getDay();
// ATTENDANCE LOOKUP MAP
const attendanceMap = {};

// ✅ Step 1: Sab dates ko "A" se fill karo
for (let i = 1; i <= daysInMonth; i++) {
  attendanceMap[i] = "A";
}
// ✅ Step 2: API data loop
attendanceData.forEach((item) => {

  if (!item.checkin_datetime) return;

  const date = parseInt(item.checkin_datetime.split("-")[2], 10);
  if (!date || date > daysInMonth) return;

  // ✅ safe JSON parse
  let jsonData = {};
  try {
    jsonData =
      typeof item.attendance_json === "string"
        ? JSON.parse(item.attendance_json)
        : item.attendance_json || {};
  } catch (e) {
    console.log("❌ Invalid JSON:", item.attendance_json);
    return;
  }

  // ✅ driverId safe match
  const driverStatus =
    jsonData[getDriverId] ||
    jsonData[getDriverId?.toUpperCase()] ||
    jsonData[getDriverId?.toLowerCase()];

  if (driverStatus) {

    // ✅ normalize
    let status = driverStatus.toString().trim().toLowerCase();

    // spaces → underscore
    status = status.replace(/\s+/g, "_");

    // custom fixes
    if (status === "halfday") status = "half_day";

    // ✅ mapping
    if (status === "present") {
      attendanceMap[date] = "P";
    } 
    else if (status === "absent") {
      attendanceMap[date] = "A";
    }
    else if (status === "half_day") {
      attendanceMap[date] = "HD";
    }
    else if (status === "leave") {
      attendanceMap[date] = "L";
    }
    else if (status === "pl") {
      attendanceMap[date] = "PL";
    }
    else {
      attendanceMap[date] = "A";
    }

  } else {
    attendanceMap[date] = "A";
  }

});
// SUMMARY COUNT
const presentCount = Object.values(attendanceMap).filter(
  s => s === "P"
).length;
const absentCount = Object.values(attendanceMap).filter(
  s => s === "A"
).length;

const halfDayCount = Object.values(attendanceMap).filter(
  s => s === "HD"
).length;

const leaveCount = Object.values(attendanceMap).filter(
  s => s === "L"
).length;

const paidleaveCount = Object.values(attendanceMap).filter(
  s => s === "PL"
).length;

const totalPresentCount=presentCount+(halfDayCount/2);
const totalAbsentCount=absentCount+(halfDayCount/2);
const totalSalaryProcess =totalDaysMonth-totalAbsentCount;
//FOR CALENDER CODE END//


  const fetchSaveConfirmAttendance = async () => {
    try {
      const res = await api.get(
        `/adminmodSalary/getConfirmSalaryData/${selectedMonth}/${selectedYear}`
      );
      console.log(res);
      setSaveConfirmAttendance(res.data?.data || []);
    } catch (err) {
      toast.error("Failed to load Salary Data");
    }
  };

  /* ================= FIX START ================= */

let drivers = [];

if (saveConfirmAttendance.length > 0) {
  try {
    const salaryData = saveConfirmAttendance[0].salary_data;

    const parsedSalary =
      typeof salaryData === "string"
        ? JSON.parse(salaryData)
        : salaryData;

    drivers = parsedSalary?.drivers || [];
  } catch (err) {
    console.error("Salary JSON parse error", err);
  }
}

  /* ================= FIX END ================= */

  const filteredDrivers = drivers.filter((d) => {
    const term = searchTerm.toLowerCase();
    return (
      d.driver_name?.toLowerCase().includes(term) ||
      d.driver_regno?.toLowerCase().includes(term)
    );
  });

  /* ================= PDF DOWNLOAD ================= */

const handlePrintPDF = async () => {
  setHideButton(true);

  // 🔥 wait for DOM update
  await new Promise((resolve) => setTimeout(resolve, 300));

  const element = tableRef.current;
  if (!element) return;

  const canvas = await html2canvas(element, {
    scale: 2,
    useCORS: true,
    scrollY: -window.scrollY,
  });

  const imgData = canvas.toDataURL("image/png");

  const pdf = new jsPDF("l", "mm", "a4");

  const pageWidth = pdf.internal.pageSize.getWidth();
  const pageHeight = pdf.internal.pageSize.getHeight();

  const imgWidth = pageWidth - 10;
  const imgHeight = (canvas.height * imgWidth) / canvas.width;

  let heightLeft = imgHeight;
  let position = 5;

  pdf.addImage(imgData, "PNG", 5, position, imgWidth, imgHeight);
  heightLeft -= pageHeight;

  while (heightLeft > 0) {
    position = heightLeft - imgHeight + 5;
    pdf.addPage();
    pdf.addImage(imgData, "PNG", 5, position, imgWidth, imgHeight);
    heightLeft -= pageHeight;
  }

  pdf.save(`salary_slip_${selectedMonth}_${selectedYear}.pdf`);

  // 🔁 show again after PDF
  setHideButton(false);
};
  
  const handlePrintPDF1 = async () => {
    const element = tableRef.current;
    if (!element) return;

    const canvas = await html2canvas(element, {
      scale: 1,
      useCORS: true,
    });

    const imgData = canvas.toDataURL("image/jpeg", 0.6);

    const pdf = new jsPDF("l", "mm", "a4");

    const pageWidth = pdf.internal.pageSize.getWidth();
    const pageHeight = pdf.internal.pageSize.getHeight();

    const imgWidth = pageWidth;
    const imgHeight = (canvas.height * imgWidth) / canvas.width;

    let heightLeft = imgHeight;
    let position = 0;

    pdf.addImage(imgData, "JPEG", 0, position, imgWidth, imgHeight);
    heightLeft -= pageHeight;

    while (heightLeft > 0) {
      position -= pageHeight;
      pdf.addPage();
      pdf.addImage(imgData, "JPEG", 0, position, imgWidth, imgHeight);
      heightLeft -= pageHeight;
    }

    pdf.save(`salary_slip_of_${selectedMonth}_${selectedYear}.pdf`);
  };


  

/* ================= DATE LOGIC ================= */

  const monthIndex = Number(selectedMonth) - 1;

  const firstDate = new Date(selectedYear, monthIndex, 1);
  const lastDate = new Date(selectedYear, monthIndex + 1, 0);

  const formatDate = (date) =>
    date
      .toLocaleDateString("en-IN", {
        day: "2-digit",
        month: "short",
        year: "numeric",
      })
      .replace(",", "");
     const salary_in_month= filteredDrivers[0]?.salary_in_month;
    const perdayAmount= salary_in_month/totalDaysMonth;
   const grtPerdayAmount= Math.round(perdayAmount);
   const total_salary_process= filteredDrivers[0]?.total_salary_process;
      const worked_days= filteredDrivers[0]?.worked_days;
      const totalpresentDaSal=worked_days*grtPerdayAmount;
        
   const totaSalary=grtPerdayAmount*total_salary_process;

     const paid_leave= filteredDrivers[0]?.paid_leave;
     const paid_leaveSalary=grtPerdayAmount*paid_leave;
     const fullSalary=paid_leave+totaSalary;

        const paymentModesend= filteredDrivers[0]?.paymentModesend;
        const net_salary= filteredDrivers[0]?.net_salary;

 const gross_salary= filteredDrivers[0]?.gross_salary;
  const leave_deduction= filteredDrivers[0]?.leave_deduction;
  const extra_allowance= filteredDrivers[0]?.extra_allowance;
   const totaldeductions= filteredDrivers[0]?.deductions.total;
const totalEarnings=(paid_leaveSalary+totalpresentDaSal+extra_allowance)-totaldeductions;
   return (
      <div className="pdf" ref={tableRef}>
  
        {/* HEADER */}
        <div style={{justifyContent:"space-between",display:"flex"}}>
        <div className="header">
          <div className="company">
            <img src={logo} alt="" />
            
          </div>
          <div className="companyFullName">
              <p>Patra Travels Private Limited</p>
            </div>
        </div>
        <div className="header">
          
          <div className="companyFullAddress">
              <p>Royal Palace Campus, Tankapani Road, Ravi Takies, Bhubaneswar, Odisha, 751018</p>
            </div>
        </div>
  </div>
  <hr style={{margin: "0rem 0"}}/>
  
  {/* <pre>{JSON.stringify(filteredDrivers, null, 2)}</pre> */}
        {/* TITLE */}
        <h3 className="title">
           Salary Slip of <span style={{backgroundColor:"#fffa0045"}}>{filteredDrivers[0]?.driver_name} ({filteredDrivers[0]?.driver_regno})</span> [{formatDate(firstDate)} – {formatDate(lastDate)}]
        </h3>
  <table>
          <thead>
            <tr>
              
              <th style={{textAlign:"center"}}>Basic Salary : <br/><i class="fa fa-inr" aria-hidden="true"></i>   {Number(salary_in_month || 0).toFixed(2)}</th>
              <th style={{textAlign:"center"}}>Leave Deduction : <br/><i class="fa fa-inr" aria-hidden="true"></i>  {Number(leave_deduction || 0).toFixed(2)}</th>
               <th style={{textAlign:"center"}}>Extra Allowance : <br/><i class="fa fa-inr" aria-hidden="true"></i>  {Number(extra_allowance || 0).toFixed(2)}</th>
              <th style={{textAlign:"center"}}>Gross Salary : <br/><i class="fa fa-inr" aria-hidden="true"></i>   {Number(gross_salary || 0).toFixed(2)}</th>
              <th style={{textAlign:"center"}}>Total Deduction : <br/><i class="fa fa-inr" aria-hidden="true"></i>   {Number(totaldeductions || 0).toFixed(2)}</th>
              <th style={{textAlign:"center"}}>Net Salary : <br/><i class="fa fa-inr" aria-hidden="true"></i>   {Number(net_salary || 0).toFixed(2)}</th>
            </tr>
          </thead>
          
        </table>
         <br/>
        {/* LOAN */}
         <p className="title">Loan Summary (Till {formatDate(lastDate)})</p>
 <table>
          <thead>
            <tr>
              <th><small>Total Loan</small><br/><span>Nil</span></th>
              <th><small>Repayment</small><br/><span>Nil</span></th>
              <th><small>Balance</small><br/><span>Nil</span></th>
            </tr>
          </thead>
          
        </table>
<br/>
       
  
        {/* TABLE 1 */}
        <p className="title">Payment & Salary ({formatDate(firstDate)} – {formatDate(lastDate)})</p>
        <table>
          <thead>
            <tr>
              <th>Details</th>
              <th>Active Date</th>
              <th>Amount</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Present <i class="fa fa-inr" aria-hidden="true"></i> {grtPerdayAmount} x {worked_days} Days</td>
              <td>-</td>
              <td className="r"><i class="fa fa-inr" aria-hidden="true"></i> {Number(totalpresentDaSal || 0).toFixed(2)}</td>
            </tr>
            <tr>
              <td>Paid Leave <i class="fa fa-inr" aria-hidden="true"></i> {grtPerdayAmount} x {paid_leave} Days</td>
              <td>-</td>
              <td className="r"><i class="fa fa-inr" aria-hidden="true"></i>  {Number(paid_leaveSalary || 0).toFixed(2)}</td>
            </tr>
            <tr>
              <td>Extra Allowance</td>
              <td>-</td>
              <td className="r"><i class="fa fa-inr" aria-hidden="true"></i>   {Number(extra_allowance || 0).toFixed(2)}</td>
            </tr>
             <tr>
              <td>Deduction  </td>
              <td>-</td>
              <td className="r"><i class="fa fa-inr" aria-hidden="true"></i>   {Number(totaldeductions || 0).toFixed(2)}</td>
            </tr>
            <tr className="b">
              <td>Total Earnings [(Present+PaidLeave+Extra Allowance)-Deduction]</td>
              <td></td>
              <td className="r"><i class="fa fa-inr" aria-hidden="true"></i>  {Number(totalEarnings || 0).toFixed(2)}</td>
            </tr>
          </tbody>
        </table>

        {/* TABLE 2 */}
        <table>
          <thead>
            <tr>
              <th>Payments</th>
              <th>Active Date</th>
              <th>Amount</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Paid - Salary {monthLabel} paid {paymentModesend === 'bank_payment' ? 'A/c transfer' : 'Cash'}</td>
              <td>{monthLabel} {year}</td>
              <td className="r"> <i class="fa fa-inr" aria-hidden="true"></i>  {Number(net_salary || 0).toFixed(2)}</td>
            </tr>
            <tr className="b">
              <td>Total Payments</td>
              <td></td>
              <td className="r"><i class="fa fa-inr" aria-hidden="true"></i>  {Number(net_salary || 0).toFixed(2)}</td>
            </tr>
          </tbody>
        </table>
 <br/>
  <div className="page-break"></div>
        {/* ATTENDANCE SUMMARY */}
        <p className="title">Attendance Summary ({formatDate(firstDate)} – {formatDate(lastDate)})</p>
        <table>
          <thead>
            <tr>
              <th>Present: {presentCount}</th>
              <th>Absent: {absentCount}</th>
              <th>Half Day: {halfDayCount}</th>
              <th>Leave : {totalAbsentCount}</th>
            </tr>
             <tr>
              <th>Paid Leave : {paidleaveCount}</th>
              <th>Total Present (Days): {totalPresentCount}</th>
              <th colSpan={"2"}>Total Salary (Days): {totalSalaryProcess}</th>
              {/* <th>Payable Days: 1</th> */}
            </tr>
          </thead>
          </table>
 
        {/* ====== 2ND PAGE CALENDAR (MERGED) ====== */}
  

   {/* WEEK HEADER */}
      <div className="calendar-header">
        {["Sun","Mon","Tue","Wed","Thu","Fri","Sat"].map((d,i)=>(
          <span key={i} >{d}</span>
        ))}
      </div>

      {/* CALENDAR GRID */}
      <div className="calendarGrid">

        {/* EMPTY SPACE BEFORE FIRST DAY */}
        {Array.from({ length: firstDay }).map((_, i) => (
          <div key={"empty"+i} ></div>
        ))}

        {/* DAYS */}
        {Array.from({ length: daysInMonth }, (_, i) => {

          const day = i + 1;
          const status = attendanceMap[day];

          return (
            <div key={day} className="calendarDays">

              <div className="cell">{day}</div>

              {status && (
                  <div className={`statusBox status${status}`}>
                  {status}
                </div>
              )}

            </div>
          );
        })}

      </div>
      <br/>
 {!hideButton && (
  <div style={{ border: "1px solid #999", textAlign: "center" }}>
    <button className="btn btn-warning" onClick={handlePrintPDF}>
      <i className="fa fa-print"></i>
    </button>
  </div>
)}
        
  
  
  
      </div>
    );
};

export default SalarySlipSinglePage;